(() => {
  if (window.realDealzContinuousCollections) return;
  window.realDealzContinuousCollections = true;

  const active = new WeakSet();
  const observer = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (entry.isIntersecting) load(entry.target.closest('[data-continuous-section]'));
    }
  }, { rootMargin: '500px 0px' });

  async function load(control) {
    if (!control || !control.isConnected || control.dataset.loading === 'true') return;
    const next = control.dataset.nextUrl;
    if (!next) return;
    control.dataset.loading = 'true';
    const button = control.querySelector('[data-load-more]');
    const status = control.querySelector('[data-load-status]');
    button.disabled = true;
    status.textContent = 'Loading more products';
    try {
      const url = new URL(next, window.location.origin);
      url.searchParams.set('section_id', control.dataset.continuousSection);
      const response = await fetch(url, { credentials: 'same-origin' });
      if (!response.ok) throw new Error('Unable to load products');
      const html = await response.text();
      const page = new DOMParser().parseFromString(html, 'text/html');
      const incoming = page.querySelector('#product-grid');
      const grid = document.querySelector('#product-grid');
      const nextControl = page.querySelector('[data-continuous-section]');
      if (!incoming || !grid || !control.isConnected) throw new Error('Product grid changed');
      const items = Array.from(incoming.children);
      grid.append(...items);
      control.dataset.nextUrl = nextControl?.dataset.nextUrl || '';
      status.textContent = items.length + ' more products loaded';
      if (!control.dataset.nextUrl || items.length === 0) {
        observer.unobserve(button);
        control.remove();
      } else {
        button.disabled = false;
      }
    } catch (error) {
      observer.unobserve(button);
      button.disabled = false;
      status.textContent = 'Could not load more products. Try the button again.';
    } finally {
      control.dataset.loading = 'false';
    }
  }

  function setup() {
    document.querySelectorAll('[data-continuous-section]').forEach((control) => {
      if (active.has(control)) return;
      active.add(control);
      control.dataset.enhanced = 'true';
      observer.observe(control.querySelector('[data-load-more]'));
    });
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-load-more]');
    if (button) load(button.closest('[data-continuous-section]'));
  });
  const gridContainer = document.querySelector('#ProductGridContainer');
  if (gridContainer) new MutationObserver(setup).observe(gridContainer, { childList: true, subtree: true });
  setup();
})();
